webpackJsonp([268040024537628],{

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Maintenance;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _SmartLink = __webpack_require__(36);
	
	var _SmartLink2 = _interopRequireDefault(_SmartLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Maintenance() {
	  var twitterLink = 'https://twitter.com/marvelapp';
	  var contactLink = 'https://help.marvelapp.com/hc/en-us/requests/new';
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'xl', position: 'topBottom' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 's', position: 'bottom' },
	      _react2.default.createElement(
	        _heading2.default,
	        { tag: 'h1', size: 'xxxl', weight: 'bold' },
	        'We\u2019ll be back soon!'
	      )
	    ),
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'm', position: 'bottom' },
	      _react2.default.createElement(
	        _maxWidth2.default,
	        { value: 370 },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'l', color: 'slate' },
	          'Marvel is unavailable while we switch over to the new Marvel 3 but we\'ll be back up in a few hours. In the meantime, you can read more on the new features and improvements and stay up to date with downtime updates on',
	          ' ',
	          _react2.default.createElement(
	            _SmartLink2.default,
	            { type: 'blue', url: twitterLink },
	            'Twitter'
	          ),
	          '.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _SmartLink2.default,
	      { url: contactLink },
	      _react2.default.createElement(
	        _button2.default,
	        { shape: 'rounded' },
	        'Get in touch'
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _difference = __webpack_require__(291);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _without = __webpack_require__(299);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _messageBlock = __webpack_require__(65);
	
	var _messageBlock2 = _interopRequireDefault(_messageBlock);
	
	var _FormWrap = __webpack_require__(202);
	
	var _FormWrap2 = _interopRequireDefault(_FormWrap);
	
	var _forms = __webpack_require__(49);
	
	var _api = __webpack_require__(54);
	
	var _fetch = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = [{
	  name: 'email',
	  label: 'Email address',
	  placeholder: 'you@example.com',
	  errorMsg: 'Please enter a valid email address',
	  type: 'email'
	}, {
	  name: 'password',
	  label: 'Password',
	  placeholder: 'Please enter your password',
	  errorMsg: 'Please enter your password',
	  type: 'password'
	}];
	
	var inputFieldNames = fields.map(function (field) {
	  return field.name;
	});
	
	var SignInForm = function (_Component) {
	  _inherits(SignInForm, _Component);
	
	  function SignInForm(props) {
	    _classCallCheck(this, SignInForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setFieldValue = function (e, fieldName) {
	      var value = e.target.value;
	      var validFields = [];
	
	      if (_this.state.validFields.indexOf(fieldName) !== -1) {
	        var _this$setState;
	
	        validFields = (0, _without2.default)(validFields, fieldName);
	        _this.setState((_this$setState = {}, _this$setState[fieldName] = value, _this$setState.validFields = validFields, _this$setState));
	      } else {
	        var _this$setState2;
	
	        _this.setState((_this$setState2 = {}, _this$setState2[fieldName] = value, _this$setState2));
	      }
	    };
	
	    _this.validateForm = function (e) {
	      e.preventDefault();
	      if (_this.isFormValid()) {
	        _this.logIn();
	      }
	    };
	
	    _this.isFormValid = function () {
	      var _this$state = _this.state,
	          email = _this$state.email,
	          password = _this$state.password;
	
	      var invalidFields = [];
	
	      if (!(0, _forms.isEmailValid)(email)) {
	        invalidFields.push('email');
	      }
	
	      if (password.length < 6) {
	        invalidFields.push('password');
	      }
	
	      var validFields = (0, _difference2.default)(inputFieldNames, invalidFields);
	
	      _this.setState({
	        invalidFields: invalidFields,
	        backendErrorMsg: '',
	        validFields: validFields
	      });
	
	      return !invalidFields.length;
	    };
	
	    _this.logIn = function () {
	      var _this$state2 = _this.state,
	          email = _this$state2.email,
	          password = _this$state2.password;
	
	      _this.setState({ isPending: true });
	      (0, _fetch.fetchApi)('POST', _api.API_LOGIN, {
	        email: email,
	        password: password
	      }).then(function () {
	        if (typeof window !== 'undefined') {
	          window.location.href = _this.props.redirectTo;
	        }
	      }).catch(function () {
	        _this.setState({
	          isPending: false,
	          backendErrorMsg: 'Invalid combination. Have another go.'
	        });
	      });
	    };
	
	    _this.state = {
	      email: '',
	      invalidFields: [],
	      isPending: false,
	      password: '',
	      backendErrorMsg: '',
	      validFields: []
	    };
	    return _this;
	  }
	
	  SignInForm.prototype.render = function render() {
	    var _state = this.state,
	        invalidFields = _state.invalidFields,
	        isPending = _state.isPending,
	        validFields = _state.validFields,
	        backendErrorMsg = _state.backendErrorMsg;
	
	
	    var redirectTo = this.props.redirectTo;
	
	    var buttonProps = {
	      text: 'Sign in',
	      color: 'green',
	      minWidth: 220,
	      tabIndex: 9
	    };
	
	    return _react2.default.createElement(
	      _FormWrap2.default,
	      {
	        action: _api.API_LOGIN,
	        autocomplete: 'on',
	        backendErrorMsg: backendErrorMsg,
	        buttonFullWidth: true,
	        buttonProps: buttonProps,
	        fields: fields,
	        googleButtonText: 'Sign in with Google',
	        invalidFields: invalidFields,
	        isPending: isPending,
	        isSignIn: true,
	        messaging: this.props.messaging,
	        redirectTo: redirectTo,
	        setFieldValue: this.setFieldValue,
	        validateForm: this.validateForm,
	        validFields: validFields
	      },
	      _react2.default.createElement(
	        _messageBlock2.default,
	        { type: 'error', fullWidth: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'fontSize-m' },
	          backendErrorMsg
	        )
	      )
	    );
	  };
	
	  return SignInForm;
	}(_react.Component);
	
	SignInForm.propTypes = {
	  redirectTo: _propTypes2.default.string,
	  messaging: _propTypes2.default.object.isRequired
	};
	exports.default = SignInForm;
	module.exports = exports['default'];

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SIGNIN_PAGE_QUERY = undefined;
	exports.default = Signin;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _forms = __webpack_require__(49);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _AccountPagesWrap = __webpack_require__(146);
	
	var _AccountPagesWrap2 = _interopRequireDefault(_AccountPagesWrap);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _Maintenance = __webpack_require__(593);
	
	var _Maintenance2 = _interopRequireDefault(_Maintenance);
	
	var _SigninForm = __webpack_require__(1212);
	
	var _SigninForm2 = _interopRequireDefault(_SigninForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Signin(_ref) {
	  var history = _ref.history,
	      data = _ref.data;
	
	  var pageProps = {
	    title: _metadata2.default.signin.title,
	    meta: [{
	      name: 'description',
	      content: _metadata2.default.signin.description
	    }, { name: 'keywords', content: _metadata2.default.signin.keywords }],
	    header: false
	  };
	
	  if (data.site.siteMetadata.siteMaintenance) {
	    return _react2.default.createElement(
	      _Page2.default,
	      pageProps,
	      _react2.default.createElement(
	        _AccountPagesWrap2.default,
	        { history: history },
	        _react2.default.createElement(_Maintenance2.default, null),
	        _react2.default.createElement('div', null)
	      )
	    );
	  }
	
	  var isCommenter = (0, _forms.getCommenterParam)();
	  var redirectTo = (0, _forms.getNextRedirectParam)();
	
	  var ssoLinkWithRedirect = (0, _forms.getUrlWithRedirect)('/sso');
	  var signupLinkWithRedirect = (0, _forms.getSignupUrlWithRedirect)();
	
	  var heading = isCommenter ? 'Sign in to leave a comment' : getTimeGreeting() + '! Welcome back.';
	
	  var messaging = {
	    header: _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'l', position: 'bottom' },
	      _react2.default.createElement(
	        _heading2.default,
	        { tag: 'h1', size: 'xxxl', weight: 'bold' },
	        heading
	      )
	    )
	  };
	
	  return _react2.default.createElement(
	    _Page2.default,
	    pageProps,
	    _react2.default.createElement(
	      _AccountPagesWrap2.default,
	      { history: history },
	      _react2.default.createElement(_SigninForm2.default, { redirectTo: redirectTo, messaging: messaging }),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', position: 'topBottom', size: 'm' },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'slate' },
	          'Secure sign in with',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: ssoLinkWithRedirect, tabIndex: 10 },
	            _react2.default.createElement(
	              _link2.default,
	              { type: 'blue' },
	              'Enterprise SSO'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'slate' },
	          'Don\'t have an account?',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: signupLinkWithRedirect, tabIndex: 11 },
	            _react2.default.createElement(
	              _link2.default,
	              { type: 'blue' },
	              'Sign up'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	var SIGNIN_PAGE_QUERY = exports.SIGNIN_PAGE_QUERY = '** extracted graphql fragment **';
	
	function getTimeGreeting() {
	  var hours = new Date().getHours();
	  if (hours >= 5 && hours <= 12) {
	    return 'Good morning';
	  } else if (hours >= 13 && hours <= 17) {
	    return 'Good afternoon';
	  } else if (hours >= 18) {
	    return 'Good evening';
	  }
	  return 'Hello';
	}
	
	Signin.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        siteMaintenance: _propTypes2.default.bool.isRequired
	      }).isRequired
	    }).isRequired
	  }).isRequired
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-signin-index-js-ef4044bda27fe021dd25.js